module.exports = __webpack_public_path__ + "img/kairan.305af966.jpg";